// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"744433f5","453":"1754a005","455":"66055b34","977":"8fb27daa"}[chunkId] + ".chunk.js";
};